import { useEffect, useState } from "react";
import Footer from "../../Components/Footer/Footer";
import JobseekerNav from "../../Components/JobseekerNav/JobseekerNav";
import FeaturesCard from "../HomePage/components/FeaturesCard";
import CategoryCard from "./components/CategoryCard";
import styles from "./Jobseeker.module.css";
import { Dialog } from "@mui/material";
import CategoryCarousel from "./components/CategoryCarousel";
import "react-multi-carousel/lib/styles.css";
import { Link } from "react-router-dom";
import clsx from "clsx";
import Chatbot from "../../Components/Chabot/Chatbot";
import { REGIONS } from "../../constants/regions";
import { useRegion } from "../../context/RegionContext";
import { images } from "../../assets/images";
import forEmployersImg from "../../assets/ksa/For_Employers_KSA.png";

const Jobseeker = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { region } = useRegion();
  useEffect(() => {
    window.scrollTo(0, 0); // This will scroll the page to the top
  }, []);

  const appStore = () => {
    window.open(
      "https://apps.apple.com/ae/app/falek-tayyeb/id6471679752",
      "_blank"
    );
  };
  const playStore = () => {
    window.open(
      "https://play.google.com/store/apps/details?id=com.falektayyeb.ft&hl=en",
      "_blank"
    );
  };

  return (
    <div className={styles.container}>
      <JobseekerNav setIsOpen={setIsOpen} />
      <div className={styles.homeContent}>
        <section id="hero" className={styles.heroSection}>
          <div className={styles.heroContent}>
            <div className={styles.empTag}>For Jobseekers</div>
            <h2 className={styles.heroText}>
              The Future Of Job Search, Exclusively For{" "}
              {region === REGIONS.AE ? "UAE" : "KSA"} Nationals
            </h2>
            <div className={styles.columnDisplayDesktop}>
              <div className={styles.heroRightImgs}>
                <img
                  src={images.imgQrCodeBlack}
                  className={styles.hideInMobile}
                />
                <div className={styles.employeeRight}>
                  <img
                    onClick={appStore}
                    src={images.appstore}
                    className={styles.downloadImg}
                  />
                  <img
                    onClick={playStore}
                    src={images.playstore}
                    className={styles.downloadImg}
                  />
                </div>
              </div>
              <div className={styles.heroDesc}>
                Click on your store or scan the QR to download
              </div>
            </div>
          </div>
          <img
            src={images.ftMockupsNew}
            className={styles.heroImage}
          />
        </section>

        <div className={styles.featuresSection}>
          <h2 className={styles.featuresHeader}>
            Available jobs by categories 💼
          </h2>
          <div className={styles.desktopCards}>
            <div className={styles.categoryCards}>
              <CategoryCard
                icon={images.tech}
                title="Technology"
              />
              <CategoryCard
                icon={images.engg}
                title="Engineering"
              />
              <CategoryCard
                icon={images.biz}
                title="Business"
              />
              <CategoryCard
                icon={images.hr}
                title="Human Resource"
              />
            </div>
            <div className={styles.categoryCards}>
              <CategoryCard
                icon={images.finance}
                title="Finance"
              />
              <CategoryCard
                icon={images.marketing}
                title="Marketing"
              />
              <CategoryCard
                icon={images.design}
                title="Design"
              />
              <CategoryCard
                icon={images.sales}
                title="Sales"
              />
            </div>
          </div>
          <div className={styles.mobileCards}>
            <CategoryCarousel />
          </div>
          <div className={styles.hideInMobile}>
            <div className={styles.btnSection}>
              <div
                onClick={() => setIsOpen(true)}
                className={styles.gradientBtn}
              >
                Download Jobseeker App
                <img src={images.btnArrow} />
              </div>
            </div>
          </div>
        </div>

        <div className={styles.gradientSection}>
          <div className={styles.topLeft}></div>
          <div className={styles.bottomRight}></div>
          <div className={styles.heroContent}>
            <h2 className={styles.heroText}>
              The Future Of Job Search, Exclusively For{" "}
              {region === REGIONS.AE ? "UAE" : "KSA"} Nationals
            </h2>{" "}
            <div className={styles.heroDesc}>DOWNLOAD THE APP</div>
            <br />
            <div className={styles.heroRightImgs}>
              <img
                onClick={appStore}
                src={images.appstore}
                className={styles.downloadImg}
              />
              <img
                onClick={playStore}
                src={images.playstore}
                className={styles.downloadImg}
              />
            </div>{" "}
          </div>
          <img
            src={images.appShowcase}
            className={clsx(styles.dashboardImg, styles.hideInMobile)}
          />
          <img
            src={images.appShowCaseMobile}
            className={clsx(styles.dashboardImg, styles.hideInDesktop)}
          />
        </div>

        <div className={styles.featuresSection}>
          <h2 className={styles.featuresHeader}>
            How Forsatak Will Elevate Your Professional Career
          </h2>
          <div className={styles.featureCards}>
            <FeaturesCard
              icon={images.effortless}
              title="Effortless Sign-Up"
              description="Register in 3 simple steps."
            />
            <FeaturesCard
              icon={images.craftStory}
              title="Craft Your Unique Story"
              description="Build a compelling profile with our intuitive guides."
            />
            <FeaturesCard
              icon={images.setSights}
              title="Set Your Sights"
              description="Define your job interests and let our cutting-edge tech do the rest."
            />
          </div>
        </div>
        <div className={styles.employeeSection}>
          <div className={styles.employeeLeft}>
            <img
              src={
                region === REGIONS.AE
                  ? images.forEmployers
                  : forEmployersImg
              }
              className={styles.employeeImg}
            />
            <div className={styles.empContent}>
              <Link to={"/"} style={{ textDecoration: "none" }}>
                <div className={styles.pageHolder}>For Employers</div>
              </Link>
              <h2 className={styles.featureTitle}>
                Do you need to hire{" "}
                {region === REGIONS.AE ? "Emirati" : "Saudi"} talent?
              </h2>
              <p className={styles.featureDesc}>
                Get your job listed on Forsatak
              </p>
            </div>
          </div>
          <Link to={"/signup"} style={{ textDecoration: "none" }}>
            <div className={styles.gradientBtn}>
              Post your first job
              <img src={images.btnArrow} />
            </div>
          </Link>
        </div>
      </div>
      <Footer />
      <Dialog
        PaperProps={{
          style: {
            borderRadius: "16px",
          },
        }}
        open={isOpen}
        className={styles.dialogWrapper}
      >
        <div className={styles.popup}>
          <h1>Download Jobseeker App</h1>
          <img
            src={images.imgQrCodeBlack}
            className={styles.popupQr}
          />
          <div className={styles.popUpBtns}>
            <img
              onClick={appStore}
              src={images.appstore}
              className={styles.downloadImg}
            />
            <img
              onClick={playStore}
              src={images.playstore}
              className={styles.downloadImg}
            />
          </div>
          <p>Click on your store or scan the QR to download</p>
          <div onClick={() => setIsOpen(false)} className={styles.gradientBtn}>
            Close
          </div>
        </div>
      </Dialog>
      <Chatbot />
    </div>
  );
};

export default Jobseeker;
